// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.separator[data-v-e978d460] {
  display: flex;
  flex-wrap: nowrap;
  justify-items: center;
  align-items: center;
  width: 100%;
  gap: 10px;
}
.separator .title[data-v-e978d460] {
  font-weight: 700;
}
.separator .line[data-v-e978d460] {
  flex: 1;
  height: 1px;
  background-color: #d8d8d8;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/apps/FlexDriveBookingRequest.vue","webpack://./FlexDriveBookingRequest.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;ACAF;ADEE;EACE,gBAAA;ACAJ;ADEE;EACE,OAAA;EACA,WAAA;EACA,yBAAA;ACAJ","sourcesContent":["\r\n.separator {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  justify-items: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  gap: 10px;\r\n\r\n  .title {\r\n    font-weight: 700;\r\n  }\r\n  .line {\r\n    flex: 1;\r\n    height: 1px;\r\n    background-color: #d8d8d8;\r\n  }\r\n}\r\n",".separator {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-items: center;\n  align-items: center;\n  width: 100%;\n  gap: 10px;\n}\n.separator .title {\n  font-weight: 700;\n}\n.separator .line {\n  flex: 1;\n  height: 1px;\n  background-color: #d8d8d8;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
